var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#plus_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "url(#plus_svg__b)",
    d: "M13 0a2 2 0 0 1 2 2v5h5a2 2 0 1 1 0 4h-5v5a2 2 0 1 1-4 0v-5H6a2 2 0 1 1 0-4h5V2a2 2 0 0 1 2-2"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "plus_svg__b",
    x1: 13,
    x2: 13,
    y1: 18,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#B25200"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.08,
    stopColor: "#F58F00"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.604,
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })))));
};
export default SvgPlus;